import { StyleObject } from 'styletron-standard'
import { ExtendedTheme } from '../theme'

/**
 * Function to ease applying style overrides as either function or object
 * @param styles Style object or style function depending on `$theme: ExtendedTheme` and any other props like `$active`, `$disbaled`, etc specified in type T
 * @returns An style object that can then be spread properly as an override
 */
export default function getStylesFromFnOrObject<T extends { $theme: ExtendedTheme } = { $theme: ExtendedTheme }>(
    styles: ((props: T) => StyleObject) | StyleObject | undefined
) {
    return function (props: T) {
        if (typeof styles === 'function') return styles(props)
        return styles
    }
}
